import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateDailyCheckIn from '@/modules/promotion/api/hooks/useMutateUpdateDailyCheckIn'
import { DailyCheckInQueryKeys } from '@/modules/promotion/keys'
import { GetDailyCheckInDataResponse } from '@/modules/promotion/type'
import { useQueryClient } from '@tanstack/react-query'

interface IsActiveDailyCheckInProps {
	row: GetDailyCheckInDataResponse
}

export function IsActiveDailyCheckIn({ row }: IsActiveDailyCheckInProps) {
	const { mutateAsync: updateDailyCheckIn } = useMutationUpdateDailyCheckIn()
	const queryClient = useQueryClient()

	const handleMutate = async (value: boolean) => {
		await updateDailyCheckIn(
			{
				id: row.id,
				payload: {
					name: row.name,
					isActive: value,
					checkInSetting: row.checkInSetting,
					turnoverRound: row.turnoverRound,
				},
			},
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: [DailyCheckInQueryKeys.GetDailyCheckIn],
					})
				},
			},
		)
	}

	return <SetIsActive defaultChecked={row.isActive} onMutate={handleMutate} />
}
